const state = {
  totalDraftsCount: null
}

export default state